import { getNavigation } from '@nextcloud/files';
import { subscribe } from '@nextcloud/event-bus';
import { onMounted, onUnmounted, shallowRef, triggerRef } from 'vue';
/**
 * Composable to get the currently active files view from the files navigation
 * @param _loaded If set enforce a current view is loaded
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useNavigation(_loaded) {
    const navigation = getNavigation();
    const views = shallowRef(navigation.views);
    const currentView = shallowRef(navigation.active);
    /**
     * Event listener to update the `currentView`
     * @param event The update event
     */
    function onUpdateActive(event) {
        currentView.value = event.detail;
    }
    /**
     * Event listener to update all registered views
     */
    function onUpdateViews() {
        views.value = navigation.views;
        triggerRef(views);
    }
    onMounted(() => {
        navigation.addEventListener('update', onUpdateViews);
        navigation.addEventListener('updateActive', onUpdateActive);
        subscribe('files:navigation:updated', onUpdateViews);
    });
    onUnmounted(() => {
        navigation.removeEventListener('update', onUpdateViews);
        navigation.removeEventListener('updateActive', onUpdateActive);
    });
    return {
        currentView,
        views,
    };
}
